<div class="container-fluid padding-top padding-bottom">
  <md-card *ngIf="!showLoading; else loading">
    <div class="row padding-bottom">
      <div class="col-md-12">
        <button class='btn btn-lg btn-primary'
                color="primary"
                (click)="goBack()">Go Back</button>
      </div>
      <div class="col-md-12 text-center">
        <h1>Meta Data</h1>
        <h3>
          <strong>STOP:</strong> If you've never read the following articles,
          <br>proceed to do so before you touch anything on this page.
          <br>Thanks.
        </h3>

        <div class="moz-list-wrap">
          <ul class="mx-auto">
            <li>
              <a href="https://moz.com/learn/seo/title-tag"
                 target="_blank">
                <h4>
                  Moz on Meta Titles
                </h4>
              </a>
            </li>
            <li>
              <a href="https://moz.com/learn/seo/meta-description"
                 target="_blank">
                <h4>
                  Moz on Meta Descriptions
                </h4>
              </a>
            </li>
            <li>
              <a href="https://moz.com/learn/seo/alt-text"
                 target="_blank">
                <h4>
                  Moz on Alt text
                </h4>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <form (ngSubmit)="save()">
      <div class="row padding-bottom">
        <div class="col-xs-6 col-xs-offset-3 text-center">
          <div class="form-froup">
            <label>Select Navigation</label>
            <p-dropdown [options]="dropdownOptions"
                        (onChange)="getSelectedNavigation()"
                        class="full-width"
                        [ngModelOptions]="{standalone: true}"
                        [(ngModel)]="selection"></p-dropdown>
          </div>
          <h6>
            Note: you can press enter while any of the below fields are highlighted to save, and crtl+s to save to
            sever.
          </h6>
        </div>
      </div>

      <ng-container *ngFor="let key of navigationKeys">
        <ng-container *ngIf="selectedNavigation[key].isDropDown; else notDropDown">
          <ng-container *ngFor="let child of selectedNavigation[key].children">
            <div *ngIf="(child.isCustomPage && selection == 'main') || !child.isCustomPage"
                 class="row py-4">
              <div class="col-xs-12 col-sm-2">
                <div class="form-group">
                  <label>Name</label>
                  <input pInputText
                         [ngModelOptions]="{standalone: true}"
                         [(ngModel)]="child.name" />
                </div>
              </div>
              <div class="col-xs-12 col-sm-2">
                <div class="form-group">
                  <label for="route">
                    <a target="_blank"
                       href="{{clientData.siteUrl}}/{{child.isCustomPage ? selectedNavigation[key].canonical+'/'+child.route : '/'+child.route}}">
                      Route
                    </a>
                  </label>
                  <input pInputText
                         [ngModelOptions]="{standalone: true}"
                         [(ngModel)]="child.route" />
                </div>
              </div>
              <div class="col-xs-12 col-sm-2">
                <div class="form-group">
                  <label>Meta Title
                    <span class="text-counter"
                          [innerHTML]="displayCount(child.metaTitle, 'title')"></span>
                  </label>
                  <input pInputText
                         [ngModelOptions]="{standalone: true}"
                         [(ngModel)]="child.metaTitle" />
                </div>
              </div>
              <div class="col-xs-12 col-sm-4">
                <div class="form-group">
                  <label>Meta Description
                    <span class="text-counter"
                          [innerHTML]="displayCount(child.metaDescription, 'description')"></span>
                  </label>
                  <textarea pInputTextarea
                            rows="2"
                            class="full-width text-area-box"
                            [ngModelOptions]="{standalone: true}"
                            [(ngModel)]="child.metaDescription"></textarea>
                </div>
              </div>
              <div class="col-xs-12 col-sm-1">
                <div class="form-group">
                  <label>Meta Image</label>
                  <input pInputText
                         [ngModelOptions]="{standalone: true}"
                         [(ngModel)]="child.metaImage" />
                </div>
              </div>
              <div class="col-xs-12 col-sm-1">
                <div class="form-group">
                  <label>Meta Image Alt</label>
                  <input pInputText
                         [ngModelOptions]="{standalone: true}"
                         [(ngModel)]="child.metaImageAlt" />
                </div>
              </div>
            </div>
          </ng-container>
        </ng-container>
        <ng-template #notDropDown>
          <div *ngIf="!selectedNavigation[key].isCustomPage || (selectedNavigation[key].isCustomPage && selection == 'main')"
               class="row py-4">
            <div class="col-xs-12 col-sm-2">
              <div class="form-group">
                <label [for]="'name'+key">Name</label>
                <input pInputText
                       [id]="'name'+key"
                       [ngModelOptions]="{standalone: true}"
                       [(ngModel)]="selectedNavigation[key].name" />
              </div>
            </div>
            <div class="col-xs-12 col-sm-2">
              <div class="form-group">
                <label [for]="'route'+key">
                  <a target="_blank"
                     href="{{clientData.siteUrl}}/{{selectedNavigation[key].route}}">
                    Route
                  </a>
                </label>
                <input pInputText
                       [id]="'route'+key"
                       [ngModelOptions]="{standalone: true}"
                       [(ngModel)]="selectedNavigation[key].route" />
              </div>
            </div>
            <div class="col-xs-12 col-sm-2">
              <div class="form-group">
                <label [for]="'metaTitle'+key">Meta Title
                  <span class="text-counter"
                        [innerHTML]="displayCount(selectedNavigation[key].metaTitle, 'title')"></span>
                </label>
                <input pInputText
                       [id]="'metaTitle'+key"
                       [ngModelOptions]="{standalone: true}"
                       [(ngModel)]="selectedNavigation[key].metaTitle" />
              </div>
            </div>
            <div class="col-xs-12 col-sm-4">
              <div class="form-group">
                <label [for]="'metaDescription'+key">Meta Description
                  <span class="text-counter"
                        [innerHTML]="displayCount(selectedNavigation[key].metaDescription, 'description')"></span>
                </label>
                <textarea pInputTextarea
                          [id]="'metaDescription'+key"
                          rows="2"
                          class="full-width text-area-box"
                          [ngModelOptions]="{standalone: true}"
                          [(ngModel)]="selectedNavigation[key].metaDescription"></textarea>
              </div>
            </div>
            <div class="col-xs-12 col-sm-1">
              <div class="form-group">
                <label [for]="'metaImg'+key">Meta Image</label>
                <input pInputText
                       [id]="'metaImg'+key"
                       [ngModelOptions]="{standalone: true}"
                       [(ngModel)]="selectedNavigation[key].metaImage" />
              </div>
            </div>
            <div class="col-xs-12 col-sm-1">
              <div class="form-group">
                <label [for]="'metaImageAlt'+key">Meta Image Alt</label>
                <input pInputText
                       [id]="'metaImageAlt'+key"
                       [ngModelOptions]="{standalone: true}"
                       [(ngModel)]="selectedNavigation[key].metaImageAlt" />
              </div>
            </div>
          </div>
        </ng-template>
      </ng-container>

      <div class="row padding-top">
        <div class="col-md-12">
          <button type="submit"
                  style="float: right;"
                  class="btn btn-lg btn-secondary"
                  color="accent">
            Save
          </button>
        </div>
      </div>
    </form>
  </md-card>
</div>

<ng-template #loading>
  <div class="spinner">
    <md-spinner color="accent"></md-spinner>
  </div>
</ng-template>
<div *ngIf="showSpinner">
  <div class="spinner">
    <md-spinner color="accent"></md-spinner>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/ng2/app/admin-portal/seo/seo.component.html